import ProxyBase from '../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getSearchPortfolio(params) {
    return this.get('Library/SearchPortfolio', params)
  }
  getTotalCompanyBySettings(params) {
    return this.post('Library/GetFilteredCompanies/all', params)
  }
  getFilteredScoreRange(params) {
    return this.get('Score/ScoreRanges', params)
  }
  getProvinceVietNam(params) {
    return this.get('Category/VietnameseLocation', params)
  }
  getVSIC(params) {
    return this.get('Category/VSIC', params)
  }
  getFilteredCompaniesBusinessSize(params) {
    return this.get('Library/FilteredCompaniesBusinessSize', params)
  }
  getFilteredCompaniesBusinessAge(params) {
    return this.get('Library/FilteredCompaniesBusinessAge', params)
  }
  getSearchExcludeCompanyInPortfolio(params) {
    return this.post('Library/SearchExcludeCompanyInPortfolio', params)
  }
  postSaveFilter(params) {
    return this.post('Library/SaveFilter', params)
  }
  getFilterDefault(params) {
    return this.get('Library/GetFilterDefault', params)
  }
  getCompanies(params) {
    return this.post('Library/GetCompanies', params)
  }
}

export default new Proxy()
